import { ResolverTag } from '@ps/web-core-enums';
import { StarsButton, Translation, useResolver } from '@ps/web-shared-components';
import React from 'react';

import styles from './../TournamentTicketsContent.scss';
import {
  TXTCLI_Download,
  TXTWCL_Please_log_in_to_our_app_in_or_ELL,
  TXTWCL_Tournament_tickets_are_current_ELL
} from './TournamentTicketsNonPokerContent.messages.json';

const TournamentTicketsNonPokerContent: React.FC = () => {
  const downloadPageLink = useResolver(ResolverTag.PSDownloadPage);

  return (
    <>
      <Translation tagName="p" {...TXTWCL_Tournament_tickets_are_current_ELL} />
      <Translation tagName="p" {...TXTWCL_Please_log_in_to_our_app_in_or_ELL} />
      <div className={styles.buttonContainer}>
        <StarsButton
          target="_blank"
          rel="noopener noreferrer"
          href={downloadPageLink}
          disabled={!downloadPageLink}
          translation={TXTCLI_Download}
        />
      </div>
    </>
  );
};

export default TournamentTicketsNonPokerContent;
